import { render, staticRenderFns } from "./mailSettingAdd.vue?vue&type=template&id=2ff3fb1c&scoped=true&"
import script from "./mailSettingAdd.vue?vue&type=script&lang=js&"
export * from "./mailSettingAdd.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingAdd.vue?vue&type=style&index=0&id=2ff3fb1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3fb1c",
  null
  
)

export default component.exports